import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { CoreConfig } from '../utils/config';

@Injectable({
  providedIn: 'root',
})
export class AppConfigService {
  private appConfig: any;
  public href: string;

  constructor(@Inject(CoreConfig.LOCAL_CONFIG) public localConfig: string, private http: HttpClient) {}

  async loadAppConfig() {
    return this.http
      .get(this.localConfig)
      .toPromise()
      .then((data) => {
        this.appConfig = data;
      });
  }

  saveConfig(config: any) {
    const url = `${this.appConfig.serverURL}/configuration/local`;
    return this.http.post(url, config);
  }

  getConfig() {
    return this.appConfig;
  }
}
